export const mainMenuItems = [
  {
    path: "/",
    title: "Home",
  },
  {
    path: "/trust",
    title: "Charitable Trust",
  },
  {
    path: "/events",
    title: "Awards & Events",
  },
  {
    path: "/about",
    title: "About Dr Tom",
  },
  {
    path: "/appointments",
    title: "Appointments",
  },
  {
    path: "/lectures-publications",
    title: "Lectures & Publications",
  },
  {
    path: "/article-library",
    title: "Article Library",
  },
  {
    path: "/videos",
    title: "Videos & Webinars",
  },
]

export const socialMenuItems = []

export const footerMenuItems = [
  {
    path: "/contact",
    title: "contact",
  },
  {
    path: "/privacy",
    title: "privacy",
  },
  {
    path: "/cookies",
    title: "cookies",
  },
]
